import React from 'react';

import { NavLink } from 'react-router-dom';
 
const Musique = () => {
    return (
        <div className="music">
            <div>
                <div className="bio-nav menu">
                    <NavLink to="/radio">
                        <h1>Radio</h1>
                    </NavLink>
                </div>
                <div className="bio-nav menu bis">
                    <NavLink to="/musique">
                        <h1>Musique</h1>
                    </NavLink>  
                </div>
                <div className="bio-nav menu">
                    <NavLink to="/doublage">
                        <h1>Doublage</h1>
                    </NavLink>
                </div>
                <div className="border"></div>
            </div> 
            <div className="intro">
                Auteur-compositeur, je fais aussi partie d'un groupe de rock espagnol appelé <span><a rel="noopener noreferrer" href="https://www.facebook.com/sietediasalhama/videos/275738833354836/" target="_blank">The Alhabama Band</a></span>.
            </div>
            <aside>
                <div className="music-img">
                    <img src={require('../img/Concerts/Affiche Custom Alhama.jpg')} alt={""} />
                </div>
                <div className="music-img">
                    <img src={require('../img/Concerts/Avec guitare 1.jpg')} alt={""} />
                </div>
                <div className="music-img">
                    <img src={require('../img/Concerts/Affiche Rock Cafe.jpeg')} alt={""} />
                </div>
            </aside>
        </div>
    );
}
 
export default Musique;